import script from "./ProductVariantsTableWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductVariantsTableWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ProductVariantsTableWrapper.vue?vue&type=style&index=0&id=49332c61&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49332c61"]])

export default __exports__